export const paths = {
  root: "/",
  launch: "/launchApp",
  launchAppContinue: "/launchAppContinue",
  launchAppContinueAAD: "/launchAppContinueAAD",
  error: "/error",
};
